import React, { PureComponent } from 'react'
import ModalDialog from '../common/ModalDialog'
import ForwardRefHOC from '../../containers/HOC/ForwardRefHOC'

class SyncVehiclesModal extends PureComponent {
  render() {
    const { forwardedRef, onConfirm } = this.props

    return (
      <ModalDialog
        title="Sync"
        ref={forwardedRef}
        confirmText="Sync"
        cancelText="Cancel"
        onConfirm={onConfirm}
      >
        <p>
          Changes made in BLAZE should be pushed to compliance system as they occur, but in the case
          a change is made directly in the compliance system or other edge cases, you may need to
          sync.
          <br />
          When doing a sync, the most current vehicle will win and overwrite.
        </p>
      </ModalDialog>
    )
  }
}

export default ForwardRefHOC(SyncVehiclesModal)



// WEBPACK FOOTER //
// ./src/components/Modal/SyncVehiclesModal.js